import { selectIsInternalAdmin } from 'accessors'
import { useSelector } from 'react-redux'

const DRIP_SEQUENCE_TEST_HOTEL_DISPLAY_IDS = [881, 223]

export function isDripSequenceEnabled({ isInternalAdmin, displayId }) {
  return (
    Boolean(isInternalAdmin) ||
    DRIP_SEQUENCE_TEST_HOTEL_DISPLAY_IDS.includes(Number(displayId))
  )
}

export function useDripSequenceEnabled() {
  const isInternalAdmin = useSelector(selectIsInternalAdmin)
  const displayId = useSelector(s => s.hotelDetails.displayId)

  return isDripSequenceEnabled({ isInternalAdmin, displayId })
}
